/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Subtitle_Export_Offset_SubtractInputs */

const en_subtitle_export_offset_subtract = /** @type {(inputs: Subtitle_Export_Offset_SubtractInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Subtract`)
};

const fr_subtitle_export_offset_subtract = /** @type {(inputs: Subtitle_Export_Offset_SubtractInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Soustraire`)
};

const de_subtitle_export_offset_subtract = /** @type {(inputs: Subtitle_Export_Offset_SubtractInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Subtrahieren`)
};

const it_subtitle_export_offset_subtract = /** @type {(inputs: Subtitle_Export_Offset_SubtractInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Sottrarre`)
};

const ru_subtitle_export_offset_subtract = /** @type {(inputs: Subtitle_Export_Offset_SubtractInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Вычесть`)
};

const es_subtitle_export_offset_subtract = /** @type {(inputs: Subtitle_Export_Offset_SubtractInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Sustraer`)
};

const zh_cn2_subtitle_export_offset_subtract = /** @type {(inputs: Subtitle_Export_Offset_SubtractInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`减去`)
};

const ja_subtitle_export_offset_subtract = /** @type {(inputs: Subtitle_Export_Offset_SubtractInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`減算`)
};

const hi_subtitle_export_offset_subtract = /** @type {(inputs: Subtitle_Export_Offset_SubtractInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`घटाना`)
};

const pt_pt2_subtitle_export_offset_subtract = /** @type {(inputs: Subtitle_Export_Offset_SubtractInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Subtrair`)
};

/**
* | output |
* | --- |
* | "Subtract" |
*
* @param {Subtitle_Export_Offset_SubtractInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const subtitle_export_offset_subtract = /** @type {((inputs?: Subtitle_Export_Offset_SubtractInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Subtitle_Export_Offset_SubtractInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return fr_subtitle_export_offset_subtract(inputs)
	if (locale === "de") return de_subtitle_export_offset_subtract(inputs)
	if (locale === "it") return it_subtitle_export_offset_subtract(inputs)
	if (locale === "ru") return ru_subtitle_export_offset_subtract(inputs)
	if (locale === "es") return es_subtitle_export_offset_subtract(inputs)
	if (locale === "zh-CN") return zh_cn2_subtitle_export_offset_subtract(inputs)
	if (locale === "ja") return ja_subtitle_export_offset_subtract(inputs)
	if (locale === "hi") return hi_subtitle_export_offset_subtract(inputs)
	if (locale === "pt-PT") return pt_pt2_subtitle_export_offset_subtract(inputs)
	return en_subtitle_export_offset_subtract(inputs)
});